import SearchIcon from '@material-ui/icons/Search'
import { Select, Menu, MenuItem, InputAdornment, InputLabel, TextField, FormGroup, FormControlLabel, Switch } from '@material-ui/core'
import React, { Fragment, Component, cloneElement, useState, useEffect } from 'react'
import {
  Datagrid, EditButton, Filter, List, TopToolbar, CreateButton, useMutation, useDataProvider,
  Button, sanitizeListRestProps, TextInput, BulkDeleteButton, BooleanInput, Pagination, SortButton
} from 'react-admin'
import { ListStyles, ListActionToolbar } from '../utilities/ListComponents'
import BulkActionButton from '../utilities/BulkActionButton'
import { keepAccessTokenUpdated, applyChangedProxy as callApplyChangedProxy, boxesBidApi as callBoxesBid } from '../utilities/extraAPIs'
import TheBox from './TheBox'
import TimerIcon from '@material-ui/icons/Timer';
import TimerOffIcon from '@material-ui/icons/TimerOff';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const TradeRevAutoProxyfilter = props => (
  <Filter {...props}>
    <TextInput resettable alwaysOn label='Search by VIN' source='vin' InputProps={{ endAdornment: (<InputAdornment position='end'><SearchIcon color='disabled' /></InputAdornment>) }} />
    <TextInput resettable label='Search by Location' source='location' InputProps={{ endAdornment: (<InputAdornment position='end'><SearchIcon color='disabled' /></InputAdornment>) }} />
    <TextInput resettable label='Search by 1&2' source='1&2' InputProps={{ endAdornment: (<InputAdornment position='end'><SearchIcon color='disabled' /></InputAdornment>) }} />
    <TextInput resettable label='Search by Winning' source='winning' InputProps={{ endAdornment: (<InputAdornment position='end'><SearchIcon color='disabled' /></InputAdornment>) }} />
    <TextInput resettable label='Search by Status' source='status' InputProps={{ endAdornment: (<InputAdornment position='end'><SearchIcon color='disabled' /></InputAdornment>) }} />
    <BooleanInput alwaysOn label='Hidden' source='hidden' />
  </Filter>
)

const TradeRevAutoProxyBulkActionButtons = props => {

  let { filterValues: { hidden } } = props
  return (
    <Fragment >
      <BulkActionButton field="API" value="Refresh" label='Refresh' {...props} />&nbsp;
      <BulkActionButton field="API" value="Get Detail" label='Get Detail' {...props} />&nbsp;
      <BulkActionButton field="hidden" value={!hidden} label={`${hidden ? 'Unhide' : 'Hide'}`} {...props} />&nbsp;
      <BulkActionButton field="API" value="Get Carfax" label='Get Carfax' {...props} />&nbsp;
      <BulkDeleteButton  {...props} />
    </Fragment>
  )
}

const ListActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  hasCreate, // you can hide CreateButton if hasCreate = false
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  sortBy,
  sortMethodOnChange,
  ...rest
}) => {

  const [isLoading, SetIsLoading] = useState(false)
  const [isBidLoading, SetIsBidLoading] = useState(false)
  const dataProvider = useDataProvider();
  const [hasProxyChanged, setHasProxyChanged] = useState(false)
  const [carCount, setCarCount] = useState(0)
  const [timerMessage, setTimerMessage] = useState('')
  const [timerTitle, setTimerTitle] = useState('')
  const [isTimerOn, setIsTimerOn] = useState(true)
  const [anchorEl, setAnchorEl] = useState(null)
  const [bidSpeed, setBidSpeed] = useState("5.3")
  const [bidSpeedButtonLabel, setBidSpeedButtonLabel] = useState("Slow")

  const updateBidSpeedButtonLabel = () => {
    let speedLabel

    switch (bidSpeed) {
      case "0":
        speedLabel = 'Off'
        break
      case "3.8":
        speedLabel = 'Bid Speed Fast'
        break
      case "4.5":
        speedLabel = 'Bid Speed Normal'
        break
      case "5.3":
        speedLabel = 'Bid Speed Slow'
        break
      default:
        speedLabel = `Bid Speed Custom (${bidSpeed}s/car)`
    }

    setBidSpeedButtonLabel(`Timer ${speedLabel}`)
  }

  const handleBidSpeedButtonClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleBidSpeedMenuClose = (event) => {
    setAnchorEl(null)
  }

  const handleBidSpeedChange = (event) => {
    let bidSpeed = event.currentTarget.dataset.bidSpeed
    if (bidSpeed === "0") {
      setIsTimerOn(false)
    } else {
      setIsTimerOn(true)
    }

    if (bidSpeed === '') {
      bidSpeed = prompt("Enter Custom Bid Speed", "6.1");
    }

    setBidSpeed(bidSpeed)
    setAnchorEl(null)
  }

  const updateTimer = () => {
    let auctionDate = new Date()
    let auctionEnd

    if (auctionDate.getHours() <= 9 && auctionDate.getMinutes() <= 45) {
      auctionEnd = new Date(auctionDate).setHours(9, 45, 0, 0) / 1000 // seconds
    } else {
      auctionEnd = new Date(new Date(auctionDate).setDate(auctionDate.getDate() + 1)).setHours(9, 45, 0, 0) / 1000 // seconds
    }

    const buffer = 0 // seconds

    const applyDuration = buffer + (carCount * bidSpeed) // seconds
    const applyTime = auctionEnd - applyDuration // seconds
    const currentTime = (new Date).getTime() / 1000 // seconds
    const timerEnd = applyTime - currentTime // seconds
    let timerFormatted

    if (timerEnd > 3600) { // 1 hour
      timerFormatted = new Date(timerEnd * 1000).toISOString().substr(11, 8)
    } else {
      timerFormatted = new Date(timerEnd * 1000).toISOString().substr(14, 5)
    }

    const applyTimeFormatted = new Date(applyTime * 1000).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })

    setTimerMessage(`In ${timerFormatted}`)
    setTimerTitle(`${applyTimeFormatted} Apply Time Based on ${carCount} Cars with Unapplied Proxy Taking ${bidSpeed} Seconds Each - Plus a ${buffer} Second Buffer`)
  }

  const refreshProxyStatus = () => {
    let sortByArr = sortBy.split(',')
    dataProvider.getList('tradeRev-auto-proxys', { pagination: { page: 1, perPage: 1000 }, sort: { field: sortByArr[0], order: sortByArr[1] }, filter: { hidden: false } }).then(({ data }) => {
      const count = data.filter(record => record.proxy_changed === true).length
      setCarCount(count)

      if (count > 0) {
        setHasProxyChanged(true)
      }
    })
  }

  useEffect(() => {
    updateBidSpeedButtonLabel()

    updateTimer()
    refreshProxyStatus()

    if (isTimerOn) {
      const countdownTimer = setInterval(updateTimer, 1000)
      const carCountTimer = setInterval(refreshProxyStatus, 3000)

      return function cleanup() {
        clearInterval(countdownTimer)
        clearInterval(carCountTimer)
      }
    } else {
      setTimerMessage('')
      setTimerTitle('')
    }
  }, [isTimerOn, bidSpeed, carCount])

  const applyChangedProxy = async () => {


    SetIsLoading(true)
    await keepAccessTokenUpdated();
    callApplyChangedProxy()
      .then(() => {
        SetIsLoading(false)
        let sortByArr = sortBy.split(',')
        dataProvider.getList('tradeRev-auto-proxys', { pagination: { page: 1, perPage: 1000 }, sort: { field: sortByArr[0], order: sortByArr[1] }, filter: {} })
          .then(({ data }) => {
            if (data.length > 0) {
              let hasOneChanged = data.some((row) => {
                return row.proxy_changed === true
              })

              setHasProxyChanged(hasOneChanged)
            }


          });

      })
  }

  const boxesBid = async () => {
    SetIsBidLoading(true);
    await keepAccessTokenUpdated();
    await callBoxesBid();
    SetIsBidLoading(false);
    // let sortByArr = sortBy.split(',')
    // let {data} = await dataProvider.getList('tradeRev-auto-proxys', { pagination: { page: 1, perPage: 1000 }, sort: { field: sortByArr[0], order: sortByArr[1] }, filter: {} });
    // if (data.length > 0) {
    //   let hasOneChanged = data.some((row) => {
    //     return row.proxy_changed === true
    //   })
    //   setHasProxyChanged(hasOneChanged)
    // }
  }

  const handleTimerOnChange = (event) => {
    setIsTimerOn(event.target.checked);
  }

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      <Button onClick={handleBidSpeedButtonClick} startIcon={isTimerOn ? <TimerIcon/> : <TimerOffIcon/>} label={bidSpeedButtonLabel} endIcon={<ArrowDropDownIcon />} color="primary" />
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleBidSpeedMenuClose}
      >
        {/* Actual Bid Speeds to Date: 3.7, 3.9, 4.4, 4.6, 5.3 */}
        <MenuItem onClick={handleBidSpeedChange} data-bid-speed="3.8" key="3.8">Fast (3.8s/car)</MenuItem>
        <MenuItem onClick={handleBidSpeedChange} data-bid-speed="4.5" key="4.5">Normal (4.5s/car)</MenuItem>
        <MenuItem onClick={handleBidSpeedChange} data-bid-speed="5.3" key="5.3">Slow (5.3s/car)</MenuItem>
        <MenuItem onClick={handleBidSpeedChange} data-bid-speed="" key="0">Custom</MenuItem>
        <MenuItem onClick={handleBidSpeedChange} data-bid-speed="0" key="0">Off</MenuItem>
      </Menu>

      <SortButton fields={['created_time', 'start', 'end']} />

      &nbsp;{filters && cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
       &nbsp;
       <CreateButton basePath={basePath} />&nbsp;&nbsp;&nbsp;
       <Button onClick={applyChangedProxy} title={timerTitle} label={isLoading ? `Processing...` : `Apply Proxies ${timerMessage}`} variant="contained" color="primary" disabled={isLoading} />&nbsp;
       <Button onClick={boxesBid} label={isBidLoading ? `Processing...` : `Bid All $100`} variant="contained" color="primary" disabled={isBidLoading} />
    </TopToolbar>
  )
};





const TradeRevAutoProxyList = (props) => {

  const [sortBy, setSortBy] = useState('end,ASC')

  const sortMethodOnChange = e => {
    let v = e.target.value
    let vArr = v.split(',')
    let url = window.location.href
    let subURL = url.substring(url.lastIndexOf('/') + 1)

    if (!subURL.includes('?')) {
      const encodedFilter = encodeURI('{"hidden":false}')
      window.location.replace(`/?#/tradeRev-auto-proxys/?filter=${encodedFilter}&page=1&perPage=1000&sort=${vArr[0]}&order=${vArr[1]}`);
    }
    else {
      let query = subURL.substring(subURL.indexOf('?') + 1);
      let queryArr = query.split('&')
      let editedQueryArr = []
      for (let index = 0; index < queryArr.length; index++) {
        let q = queryArr[index];
        if (q.startsWith('sort')) {
          q = `sort=${vArr[0]}`
        }
        else if (q.startsWith('order')) {
          q = `order=${vArr[1]}`
        }
        editedQueryArr.push(q)
      }
      let editedURL = '/?#/tradeRev-auto-proxys/?'
      for (let index = 0; index < editedQueryArr.length; index++) {
        let q = editedQueryArr[index];
        if (index == 0)
          editedURL += q
        else
          editedURL += '&' + q
      }
      window.location.replace(editedURL);

    }

    setSortBy(v)
  }


  return (
    <List
      {...props}
      filterDefaultValues={{ hidden: false }}
      bulkActionButtons={<TradeRevAutoProxyBulkActionButtons />}
      filters={<TradeRevAutoProxyfilter />}
      sort={{ field: 'end', order: 'ASC' }}
      perPage={1000}
      pagination={<Pagination rowsPerPageOptions={[1000]} />}
      actions={
        <ListActions
          sortBy={sortBy}
          sortMethodOnChange={sortMethodOnChange}
        />}
    >
      <Datagrid >
        <TheBox />
        <ListActionToolbar>
          <EditButton />
        </ListActionToolbar>

      </Datagrid>
    </List>
  )

}

export default TradeRevAutoProxyList
